import { ILicense } from "../../models/index";
import { updateLicense } from "../../services/index";
import { toastError, toastSuccess } from "../../utils/index";
import { Toast } from "primereact/toast";
import { useMutation, useQueryClient } from "react-query";

export const useUpdateLicenseData = (toast: React.RefObject<Toast>) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading: updateLicenseIsLoading } = useMutation(
    async (license: ILicense) => await updateLicense(license),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("licenses");
        toastSuccess(toast, "License Updated");
      },
      onError: () => {
        toastError(toast, "License not Updated");
      },
    }
  );
  return { mutate, updateLicenseIsLoading };
};
